import wretch, { WretcherOptions } from 'wretch';

// This is a wrapper over the 'wretch' library
// https://github.com/elbywan/wretch

// Anything custom meant to be attached for all api calls (e.g. attaching custom CSRF header)
// can be attached here.

export default function fetcher(url: string, options?: WretcherOptions) {
  return wretch(url, options);
}
